<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="copy"></a><a id="page_iv"></a>© 2008 The Johns Hopkins University Press</p>
<p class="copyrightb1">All rights reserved. Published 2008</p>
<p class="copyrightb1">Printed in the United States of America on acid-free paper</p>
<p class="copyrightb">9 8 7 6 5 4 3 2 1</p>
<p class="copyrightb">The Johns Hopkins University Press<br/>2715 North Charles Street<br/>Baltimore, Maryland 21218-4363<br/><span class="weblink"><a href="http://www.press.jhu.edu" target="_blank">www.press.jhu.edu</a></span></p>
<p class="copyrightb"><em>Library of Congress Cataloging-in-Publication Data</em><br/>Lucier, Paul, 1962–</p>
<p class="copyrightb2">Scientists and swindlers : consulting on coal and oil in America,<br/>1820–1890 / Paul Lucier.</p>
<p class="copyrightb3">p. cm. — (Johns Hopkins studies in the history of technology)</p>
<p class="copyrightb2">Includes bibliographical references and index.</p>
<p class="copyrightb2">ISBN-13: 978-0-8018-9003-1 (hardcover : alk. paper)</p>
<p class="copyrightb2">ISBN-10: 0-8018-9003-9 (hardcover : alk. paper)</p>
<p class="copyrightb2">1. Science and industry—Moral and ethical aspects—United States—<br/>History—19th century. 2. Petroleum industry and trade—United States<br/>—History—19th century. 3. Petroleum industry and trade—Canada—<br/>History—19th century. 4. Coal trade—United States—History—19th<br/>century. 5. Coal trade—Canada—History—19th century. 6. Science<br/>and law—United States—History—19th century. I. Title.</p>
<p class="copyrightb2">Q127.U6L83 2008</p>
<p class="copyrightb2">509.73′09034—dc22                   2008006551</p>
<p class="copyrightb">A catalog record for this book is available from the British Library.</p>
<p class="copyrightb"><em>Special discounts are available for bulk purchases of this book.</em><br/><em>For more information, please contact Special Sales at 410-516-6936</em><br/><em>or specialsales@press.jhu.edu.</em></p>
<p class="copyrightb">The Johns Hopkins University Press uses environmentally friendly book<br/>materials, including recycled text paper that is composed of at least 30<br/>percent post-consumer waste, whenever possible. All of our book papers<br/>are acid-free, and our jackets and covers are printed on paper with<br/>recycled content.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04_copy.vue?6cce8d7e